import GsButtonGroup from "./gs-button-group.vue"
const component = {
  install: (Vue) => {
    Vue.component('GsButtonGroup', GsButtonGroup)
  }
}
export default component